import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const ServiceArea = () => {
  const cities = [
    'Saint-Julien-sur-Bibost',
    'Lyon',
    'Brignais',
    'L\'Arbresle',
    'Tarare',
    'Lentilly',
    'Saint-Pierre-la-Palud',
    'Vaugneray',
    'Pollionnay',
    'Yzeron',
    'Grézieu-la-Varenne',
    'Craponne'
  ];

  return (
    <section id="zone" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Zone <span className="text-blue-600">d'intervention</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Intervention dans un rayon de 50 km autour de Saint-Julien-sur-Bibost, 
            incluant Lyon, les Monts du Lyonnais et les communes environnantes
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Map */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden h-[450px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d89635.69!2d4.5841!3d45.7481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4a8fc0e7e6d39%3A0x408ab2ae4bb21f0!2s122%20Route%20D%C3%A9partementale%2024%2C%2069690%20Saint-Julien-sur-Bibost!5e0!3m2!1sfr!2sfr!4v1234567890"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Zone d'intervention Franck Curiotti Carrelage"
              ></iframe>
            </div>
            <div className="absolute top-4 left-4 bg-white rounded-lg shadow-lg p-4 flex items-center gap-3">
              <div className="bg-blue-600 rounded-full p-2">
                <MapPin className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">Basé à</p>
                <p className="text-sm text-gray-600">Saint-Julien-sur-Bibost</p>
              </div>
            </div>
          </div>

          {/* Cities List */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-blue-100 rounded-full p-3">
                <Navigation className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">
                Communes desservies
              </h3>
            </div>
            
            <p className="text-gray-600 mb-6">
              Nous intervenons dans les Monts du Lyonnais et le Rhône (69), 
              dans un rayon de 50 km autour de notre base.
            </p>

            <div className="grid sm:grid-cols-2 gap-3">
              {cities.map((city, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg hover:bg-blue-50 transition-colors"
                >
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{city}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-100">
              <p className="text-sm text-gray-700">
                <strong className="text-blue-700">Votre commune n'est pas listée ?</strong>
                <br />
                Contactez-nous ! Nous étudions toutes les demandes dans un rayon de 50 km.
              </p>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 text-center">
                Pour vérifier votre éligibilité, contactez-nous par téléphone
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
